import { Mark } from "@material-ui/core";
import { Slider as MuiSlider } from "@mui/material";
import classNames from "classnames";

import styles from "./Slider.module.scss";

export enum SliderVariant {
  Green = "green",
  Orange = "orange",
}

interface SliderProps {
  value?: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
  marks?: Mark[];
  variant?: SliderVariant;
  steps?: number;
  isDisabled?: boolean;
}

export const Slider: React.FC<SliderProps> = ({
  value,
  onChange,
  min,
  max,
  marks,
  variant = SliderVariant.Green,
  steps = 0.01,
  isDisabled = false,
}) => {
  return (
    <div className={classNames(styles.container, styles[variant], { [styles.disabled]: isDisabled })}>
      <MuiSlider
        value={value}
        onChange={(_, newValue) => {
          onChange(newValue as number);
        }}
        min={min}
        step={steps}
        marks={marks}
        max={max}
        disabled={isDisabled}
      />
    </div>
  );
};
